<script setup>
import { ref } from "vue";
import { t } from "@/controllerLK/GlobusLocalization";
import { locales as globusLocales } from "@/controllerLK/GlobusLocalization";
import { useStore } from "@/store";
import ChevronDown from "@/assets/icons/ChevronDown.vue";
import ChevronUp from "@/assets/icons/ChevronUp.vue";

const locales = JSON.parse(JSON.stringify(globusLocales));
const store = useStore();

const isShowLanguageDropdown = ref(false);

const selectedLanguage = (lang) => {
  isShowLanguageDropdown.value = false;
  localStorage.setItem("globusLanguage", lang);
  store.language.code = lang;
};
</script>

<template>
  <div class="language-selector">
    <div
      class="language-selector__selected"
      :class="{'language-selector__selected_active': isShowLanguageDropdown}"
      @click="isShowLanguageDropdown = !isShowLanguageDropdown"
    >
      {{ t('login_page.language.' + store.language.code) }}
      <ChevronUp v-if="isShowLanguageDropdown" />
      <ChevronDown v-else />
    </div>
    <div
      v-if="isShowLanguageDropdown"
      v-click-outside="() => isShowLanguageDropdown = false"
      class="language-selector-dropdown"
    >
      <div
        v-for="lang in locales"
        :key="lang"
        class="language-selector-dropdown__item"
        :class="{'language-selector-dropdown__item_active': lang.code === store.language.code}"
        @click="selectedLanguage(lang.code)"
      >
        <img
          :src="require(`/public/icons/countries/${lang.code}.png`)"
          alt=""
        >
        {{ t('login_page.language.' + lang.code) }}
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.language-selector {
  position: relative;

  &__selected {
    display: flex;
    align-items: center;
    gap: 5px;
    cursor: pointer;
    user-select: none;
    color: #898989;
    &_active {
      color: #1F9AFF;
    }
  }

  &-dropdown {
    top: calc(100% + 10px);
    right: 0;
    border-radius: 8px;
    padding: 6px;
    display: flex;
    flex-direction: column;
    gap: 4px;
    background: #FFF;
    color: #212327;

    box-shadow: 1px 2px 10px 0 #131E2726;
    position: absolute;

    &__item {
      display: flex;
      align-items: center;
      gap: 4px;
      border-radius: 8px;
      cursor: pointer;
      user-select: none;
      padding: 6px 14px;

      img {
        width: 21px;
        height: 14px;
      }

      &_active {
        background: #E0F0FF;
      }

      &:hover {
        background: #EEF1F4;
      }
    }
  }
}
</style>